module.exports = __webpack_public_path__ + "img/ru.1fad6551.svg";